import React, { useCallback, useContext, useMemo } from 'react'
import OfferDurationOptions from '../../Duration/OfferDurationOptions'
import Modal from 'components/Luxkit/Modal/Modal'
import { OfferPageActions, takeCurrentOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { getDurationOptions } from 'selectors/offerPage/offerPageSelectors'
import { OfferDurationOption } from '../../DurationTabs/OfferDurationTabs'
import { min } from 'lib/array/arrayUtils'
import { CALENDAR_GA_EVENT_ACTION, CALENDAR_GA_EVENT_LABEL } from 'constants/analytics'
import UserAnalyticsActionContext from 'contexts/userAnalyticsActionContext'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import { pluralizeToString } from 'lib/string/pluralize'

interface Props {
  duration: number;
  durationOptions: Array<OfferDurationOption>;
}

function OfferCalendarDurationModal(props: Props) {
  const { durationOptions } = props

  const onUserAnalyticsAction = useContext(UserAnalyticsActionContext)
  const dispatch = useOfferPageDispatch()
  const minDuration = useMemo(() => min(durationOptions, duration => duration.duration)?.duration!, [durationOptions])
  const modalElement = useModalElementContext()

  const onDurationSelect = useCallback(() => {
    dispatch({ type: OfferPageActions.closeSubFilter })
    modalElement?.resolve()
    onUserAnalyticsAction?.(CALENDAR_GA_EVENT_ACTION.CloseSubFilter, CALENDAR_GA_EVENT_LABEL.OpenDuration)
  }, [dispatch, modalElement, onUserAnalyticsAction])

  return <Modal
    title="How long do you want to stay?"
    subtitle={minDuration > 1 ? `Minimum stay for this offer is ${pluralizeToString('night', minDuration)}` : undefined}
  >
    <OfferDurationOptions onSelect={onDurationSelect} />
  </Modal>
}

export default withOfferPageAndReduxState((currentState, appState) => {
  const state = takeCurrentOfferState(currentState)

  return {
    duration: state.duration,
    durationOptions: getDurationOptions(currentState, appState),
  }
}, OfferCalendarDurationModal)
